import React, { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router'
import styled from 'styled-components'
import StyledIcon from '../../../components/Icon'
import useCountDown from '../../../hooks/useCountDown'
import { DateTime, padTime } from '../../../utils/datetime'
import { _ } from '../../../utils/localization'
import { addModal } from '../../modals/modalSlice'
import useSlug from '../../../hooks/useSlug'
import getPathForSpace from '../../../utils/spaces/getPathForSpace'
import { ParamSlug } from '../../../types'

const S = {
    TimeLeft: styled.div`
        display: flex;
        align-items: center;
        width: 100%;
        padding: 10px 0;
        border-top: 1px solid rgba(255, 255, 255, 0.2);
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        color: white;
        font-size: 18px;
    `
}

const NearlyEndModal = ({ close }: { close: () => void }) => (
    <>
        <p>{_('meeting.videocall.nearly_end_body')}</p>
        <Button onClick={close} style={{ display: 'block', marginLeft: 'auto' }}>
            {_('meeting.videocall.nearly_end_confirm_button')}
        </Button>
    </>
)

const TimeLeft = ({ end_date }: {end_date: DateTime}) => {
    const params = useParams<ParamSlug>()
    const meetingSlug = useSlug('meetingSlug')
    const {
        hoursLeft, minutesLeft, secondsLeft, totalSeconds
    } = useCountDown(end_date)
    const dispatch = useDispatch()
    const history = useHistory()

    useEffect(() => {
        if (!totalSeconds) {
            history.push(getPathForSpace({
                type: 'meeting',
                slug: meetingSlug,
            }, params))
        }
    }, [history, meetingSlug, params, totalSeconds])

    useEffect(() => {
        if (!hoursLeft && !minutesLeft && secondsLeft === 30) {
            dispatch(addModal({
                header: _('meeting.videocall.nearly_end_header'),
                Component: NearlyEndModal
            }))
        }
    }, [dispatch, hoursLeft, minutesLeft, secondsLeft])

    return (
        <S.TimeLeft>
            <StyledIcon icon="clock" size={18} color="white" style={{ margin: '0 5px 3px 0' }} />
            {`${_('meeting.videocall.time_left')}: ${padTime(hoursLeft)}:${padTime(minutesLeft)}:${padTime(secondsLeft)}`}
        </S.TimeLeft>
    )
}

export default TimeLeft
